import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import { logoutSession } from "../util/authorization";
import { useRouter } from "../util/router";
import { useUser } from "../util/user";

function ErrorPage() {
	const router = useRouter();
	const userObj = useUser();
	const { keycloak, initialized } = useKeycloak();

	const styleContainer = {
		height: "92vh",
		backgroundColor: "#f9f9f9",
		fontSize: "28px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	};

	useEffect(() => {
		// User is authenticated
		if (userObj == null) {
			router.push("/solar/logout");
		} else if (userObj.groups.length > 0) {
			router.push("/solar/overview");
		}
	}, [userObj]);

	return (
		<div style={{ height: "92vh" }}>
			<div style={styleContainer}>
				<Container>
					<h1 style={{ fontSize: "xxx-large", paddingBottom: "4%" }}>Error!</h1>
					<h4>Please contact the project manager in charge.</h4>
					<Button
						onClick={() => {
							const keycloakID = keycloak.tokenParsed.sub;
							logoutSession(keycloakID);
							keycloak.logout();
							router.push("/solar/logout");
						}}
					>
						Logout
					</Button>
				</Container>
			</div>
		</div>
	);
}

export default ErrorPage;
